<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Xem điểm:</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <div>
      <div class="d-flex justify-content-center align-items-center">
        <div class="class-user-info">
          <div class="class-user-info-content">
            <div>
              <span class="line-1">Mã sinh viên</span>
              <strong>{{ modelData.user_code }}</strong>
            </div>
            <div>
              <span class="line-1">Tên sinh viên</span>
              <strong>{{ modelData.user_name }}</strong>
            </div>
            <div>
              <span class="line-1">Phái</span>
              <span>{{ modelData.user_sex }}</span>
            </div>
            <div>
              <span class="line-1">Nơi sinh</span>
              <span>{{ modelData.user_city_name }}</span>
            </div>
            <div>
              <span class="line-1">Lớp</span>
              <span>{{ modelData.class_pro_code }}</span>
            </div>
            <div>
              <span class="line-1">Chuyên ngành</span>
              <strong>{{ modelData.facult_text }}</strong>
            </div>
            <div>
              <span class="line-1">Phân hệ</span>
              <strong>{{ modelData.level_text }}</strong>
            </div>
            <div>
              <span class="line-1">Khóa học</span>
              <strong>{{ modelData.class_pro_year }}</strong>
            </div>
            <div>
              <span class="line-1">Cố vấn học tập</span>
              <span>{{ modelData.user_teacher_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-3" v-loading="loading">
      <table id="firstTable">
        <thead>
          <tr>
            <th scope="col">STT</th>
            <th scope="col">Mã môn</th>
            <th scope="col">Tên môn</th>
            <th scope="col">Chuyên cần</th>
            <th scope="col">Điểm giữa môn</th>
            <th scope="col">Kết thúc môn</th>
            <th scope="col">TB môn</th>
            <th scope="col">Kết quả</th>
          </tr>
        </thead>
        <tbody v-for="(term, index_term) in listScore" :key="index_term">
          <tr>
            <td colspan="9" class="term-result">
              <strong>Kì {{ index_term + 1 }}</strong>
            </td>
          </tr>
          <tr v-for="item in term" :key="item.course_code">
            <td width="50">{{ item.course_position }}</td>
            <td width="80">{{ item.course_code }}</td>
            <td width="450">{{ item.course_name }}</td>
            <td width="70" class="text-center">
              <span class="click-point" v-if="item.type14" @click="updateScoreAttendance(item.booking_id)">{{ item.score_attendance }}</span>
            </td>
            <td width="70" class="text-center">
              <el-popover
                v-if="item.type12 !== null"
                placement="top"
                title="Hành động"
                width="50"
                trigger="hover">
                <div class="module-action">
                  <el-tooltip effect="dark" content="Xem" placement="top">
                    <span @click="showScore(item, 'type12')">
                      <i class="fas fa-search icon-search"></i>
                    </span>
                  </el-tooltip>
                </div>
                <el-button slot="reference">{{ item.type12 }}</el-button>
              </el-popover>
            </td>
            <td width="70" class="text-center">
              <el-popover
                v-if="item.type14 !== null"
                placement="top"
                title="Hành động"
                width="50"
                trigger="hover">
                <div class="module-action">
                  <el-tooltip effect="dark" content="Xem" placement="top">
                    <span @click="showScore(item, 'type14')">
                      <i class="fas fa-search icon-search"></i>
                    </span>
                  </el-tooltip>
                </div>
                <el-button slot="reference">{{ item.type14 }}</el-button>
              </el-popover>
            </td>
            <td width="90" class="text-center">{{ item.dtbm }}</td>
            <td width="90" class="text-center">{{ item.text_result }}</td>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <td colspan="9" class="term-result">
              <strong>Tốt nghiệp</strong>
            </td>
          </tr>
          <tr>
            <td width="50">1</td>
            <td width="80">TN001</td>
            <td width="450">Lý thuyết</td>
            <td width="70" class="text-center"></td>
            <td width="70" class="text-center"></td>
            <td width="70" class="text-center"></td>
            <td width="90" class="text-center"></td>
            <td width="90" class="text-center"></td>
          </tr>
          <tr>
            <td width="50">2</td>
            <td width="80">TN002</td>
            <td width="450">Thực hành nghề</td>
            <td width="70" class="text-center"></td>
            <td width="70" class="text-center"></td>
            <td width="70" class="text-center"></td>
            <td width="90" class="text-center"></td>
            <td width="90" class="text-center"></td>
          </tr>
          <tr>
            <td width="50">3</td>
            <td width="80">TN003</td>
            <td width="450">Báo cáo thực tập</td>
            <td width="70" class="text-center"></td>
            <td width="70" class="text-center"></td>
            <td width="70" class="text-center"></td>
            <td width="90" class="text-center"></td>
            <td width="90" class="text-center"></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Xem điểm -->
    <el-dialog
      :close-on-click-modal="false"
      :title="'Kết quả thi'"
      :visible.sync="dialogVisible"
      top="20px"
      width="65%">
      <div>
        <el-row :gutter="20">
          <el-col :span="16">
            <div class="test-list-result">
              <div class="item-question" v-for="(question, indexQuestion) in modelScore.list_results" :key="indexQuestion">
                <div>
                  <strong>Câu {{ indexQuestion + 1 }} : </strong>
                  <strong v-html="question.text"></strong>
                </div>
                <div class="list-options test-options" v-if="modelScore.type_question == 1">
                  <el-checkbox-group v-model="question.model_option">
                    <el-checkbox :label="option.id" v-for="(option,index) in question.options.data" :key="option.id">
                        <span>{{ returnTitle(index) }}</span>
                        <span v-if="option.is_answer" style="color: green">{{ option.text }}</span>
                        <span v-else>{{ option.text }}</span>
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
                <div class="list-options test-options mb-2" v-if="modelScore.type_question == 2">
                    <div class="file-upload-done pb-2 d-flex align-items-center" v-if="question.model_option.length">
                        <i class="far fa-file-alt"></i>
                        <span class="name">{{ question.model_option_name }}</span>
                        <i class="far fa-clock"></i>
                        <span class="time">{{ question.model_option_time }}</span>
                        <i class="far fa-eye"></i>
                        <a :href="question.model_option" target="_blank" class="view">Xem</a>
                    </div>
                    <div v-else>
                        <i>- Không có câu trả lời</i>
                    </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="test-info">
              <div>
                <strong>Tên đề thi:</strong>
                <span>{{ modelScore.name }}</span>
              </div>
              <div>
                <strong>Khóa học:</strong>
                <span>{{ modelScore.course_name }}</span>
              </div>
              <div>
                <strong>Học viên :</strong>
                <span>{{ modelScore.user_name }}</span>
              </div>
              <div>
                <strong>Tổng số câu hỏi :</strong>
                <span>{{ modelScore.total_question }}</span>
              </div>
              <div>
                <strong>Tổng số câu trả lời :</strong>
                <span>{{ modelScore.total_answer }}</span>
              </div>
              <div>
                <strong>Tổng số câu trả lời đúng:</strong>
                <span>{{ modelScore.total_success }}</span>
              </div>
              <div>
                <strong>Điểm số:</strong>
                <span>{{ modelScore.score }} điểm</span>
              </div>
              <div>
                <strong>Đạt điều kiện vượt qua bài kiểm tra:</strong>
                <span>{{ modelScore.score_status_txt }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button @click="confirmSubmitSave(modelScore)" size="small el-button el-button--warning el-button--small">Cập nhật</el-button>
          <el-button @click="dialogVisible = false" size="small">Cancel</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
export default {
  name: 'ShowScore',
  metaInfo () {
    return {
      title: 'Lớp học'
    }
  },
  data () {
    return {
      loading: false,
      canSubmit: true,
      modelData: {},
      listScore: [],

      // Xem
      dialogVisible: false,
      modelScore: {},

      // Lop:
      modelDataClassPro: {}
    }
  },
  mounted () {
    this.fetchModelClassPro()
    this.fetchModel()
    this.fetchDatabaseModel()
  },
  methods: {
    confirmSubmitSave (model) {
      this.$confirm('Xác nhận sửa đáp án bài thi ?', 'Xác nhận', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Hủy bỏ',
        type: 'warning'
      }).then(() => {
        this.submitSave(model)
      }).catch(() => {

      })
    },
    submitSave (model) {
      this.canSubmitSave = false;
      let data = {
        'list_results': this.modelScore.list_results
      }
      axios.post('test-results/update-test-result/' + model.id, data).then(response => {
        this.canSubmitSave = true;
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Chỉnh sửa thành công',
              type: 'success',
              duration: '2000'
            })
            this.modelScore = response.data
            this.fetchDatabaseModel()
            break
          case 404:
            break
          default:
            break
        }
      })
    },
    returnTitle (index) {
      if (index === 0) return 'A.'
      if (index === 1) return 'B.'
      if (index === 2) return 'C.'
      if (index === 3) return 'D.'
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-pros-index', text: 'Lớp học' },
        { name: 'class-pros-show-list-user', id: this.$route.params.id, text: 'Lớp: ' + this.modelDataClassPro.code },
        { name: 'class-pros-update1', text: 'Xem kết quả thi' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'class-pros-show', params: {id: this.$route.params.id}})
    },
    // Tải dữ liệu Model xuống
    fetchModelClassPro () {
      this.canSubmit = false
      axios.get('class-pros/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelDataClassPro = response.data
            this.configBreadcrumb()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('class-users/' + this.$route.params.id_class_user).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchDatabaseModel () {
      this.loading = true
      axios.post('class-users/view-scores-v2/' + this.$route.params.id_class_user).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.listScore = response.data
            break
          case 404:
            break
          default:
            break
        }
      })
    },
    showScore (model, type) {
      this.dialogVisible = true
      let id
      if (type === 'type1') {
        id = model.type1_test_result_id
      }
      if (type === 'type12') {
        id = model.type12_test_result_id
      }
      if (type === 'type14') {
        id = model.type14_test_result_id
      }
      axios.get('test-results/' + id).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.modelScore = response.data
            break
          case 404:
            break
          default:
            break
        }
      })
    },

    updateScoreAttendance (bookingId) {
      this.$prompt('Nhập số điểm chuyên cần muốn chỉnh sửa', 'Tip', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
      }).then(({ value }) => {
        this.updateScoreAttendanceAction(bookingId, value)
      }).catch(() => {
      })
    },
    updateScoreAttendanceAction (bookingId, value) {
      let data = {
        score_attendance: value
      }
      axios.post('class-users/update-score-attendance/' + bookingId, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.fetchDatabaseModel()
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>

<style type="text/css" scoped>
  .list-score {
    min-height: 500px;
  }

  .class-user-info {
    background-color: #7FC1ED;
    width: 420px;
    border-radius: 6px;
    margin-top: 10px;
    padding: 12px 15px 6px 15px;
    margin-bottom: 30px;
  }
  .class-user-info-content {
    height: 100%;
    background-color: #fff;
    border-radius: 5px;
    padding: 8px 15px;
    border: 1px solid #3A87A3;
    font-size: 12px;
  }
  .line-1 {
    min-width: 125px;
    display: inline-block
  }

  .class-user-data .term-result {
    background-color: #CCCCCC !important;
  }

  /*// Table*/
  /*https://www.developerdrive.com/creating-a-data-table-in-vue-js/*/
  table {
    width: 100%;
    border-collapse: collapse;
    border: 1px solid #E8EBEE;
  }

  table th {
    text-transform: uppercase;
    text-align: left;
    background: #fff;
    color: #000;
    padding: 8px;
    min-width: 30px;
  }

  table td {
    text-align: left;
    padding: 8px;
    border-right: 1px solid #E8EBEE;
    border-bottom: 1px solid #E8EBEE;
  }
  table tr:hover {
    background-color: #f2f2f2;
  }
  table td:last-child {
    border-right: none;
  }

  table .term-result {
    background-color: #ccc;
  }

  table td.text-center {
    text-align: center;
  }
</style>

<style type="text/css" scoped>
  .test-list-result {
    height: 500px;
    overflow-y: scroll;
  }

  /*// Copy từ con web*/
  .course-test {
    min-height: 100vh;
  }
  .test-content {
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .name-company {
    max-width: 200px;
    text-align: left;
  }
  .name-company .name {
    text-transform: uppercase;
    font-weight: bold;
  }
  .name-company-mobile {
    width: 100%;
  }

  .name-company-mobile .name {
    text-transform: uppercase;
    font-weight: bold;
  }
  @media screen and (min-width: 768px) {
    .name-company .name {
      font-size: inherit;
    }
   .name-company .name-2 {
      min-height: 40px;
   }
  }
  .name-test-kit {
    text-align: right;
    max-width: 200px;
    margin-left: 15px;
  }
  @media screen and (min-width: 375px) {
    .name-test-kit {
      text-align: right;
      max-width: 250px;
    }
  }
  @media screen and (min-width: 768px) {
    .name-test-kit {
      max-width: 480px;
    }
  }
  .name-test-kit .name {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: bold;
  }
  @media screen and (min-width: 768px) {
    .name-test-kit .name {
      font-size: 15px;
    }
  }
  .name-test-kit .hold {
    text-transform: initial;
  }

  .item-question {
    margin-top: 15px;
  }
  .list-options .form-check {
    margin: 8px 0px;
  }
  .list-options .form-check input,
  .list-options .form-check label {
    cursor: pointer !important;
  }

  .test-info-sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 15px;
  }
  .test-info {
    margin-top: 15px;
    padding: 15px;
    border-radius: 2px;
    background-color: #f2f2f2;
  }

  .test-options {

  }
  .test-options .el-radio-group {
    display: flex;
    flex-direction: column;
  }
  .test-options .el-radio {
    margin-left: 0px !important;
    line-height: 25px;
  }
  .test-options .el-radio:hover {
    color: #28A90C !important;
  }

  .test-kit-done {
    background-color: #f8f8f8;
    padding: 10px;
  }
</style>

<style>
  .test-list-result .el-radio {
    white-space: inherit;
    margin-bottom: 7px;
    line-height: 20px;
  }
  .el-input__icon {
      line-height: 25px !important;
  }

  .el-checkbox-group {
      display: flex;
      flex-direction: column;
  }
  .el-checkbox {
      margin-left: 0px !important;
      line-height: 2;
  }
</style>
<style type="text/css" scoped="">
  .click-point {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/class-pros/ShowScoreV2.vue